module.exports = "<div class=\"aside\" id=\"installmentOptions\">\n    <xo-aside-header heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <xo-installment-options token=\"token\" done-fn=\"onComplete\"></xo-installment-options>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/template.html
// module id = ./pages/xo-sidebar-installment-options/template.html
// module chunks = 1